import dayjs, { Dayjs } from "dayjs";
import { DATE_FORMATS } from "../constants/app";

export const dateHelpers = {
  // Obtener rango de fechas
  getDateRange: (monthsBack: number, monthsForward: number) => ({
    desde: dayjs().subtract(monthsBack, "months").format(DATE_FORMATS.API_WITH_TIME),
    hasta: dayjs().add(monthsForward, "months").format(DATE_FORMATS.API_WITH_TIME),
  }),

  // Formatear fecha legible
  toReadableDate: (fecha: string | Dayjs): string => {
    const date = dayjs(fecha);
    const nombreDia = date.format("dddd");
    const diaCapitalizado = nombreDia.charAt(0).toUpperCase() + nombreDia.slice(1);
    return `${diaCapitalizado} ${date.format("DD")} de ${date.format("MMMM, YYYY")}`;
  },

  // Comparar si es hoy
  isToday: (fecha: string | Dayjs): boolean => {
    return dayjs(fecha).isSame(dayjs(), "day");
  },

  // Calcular edad
  calculateAge: (fechaNacimiento: string): number => {
    return dayjs().diff(fechaNacimiento, "year");
  },

  // Es fecha futura
  isFutureDate: (fecha: string | Dayjs): boolean => {
    return dayjs(fecha).isAfter(dayjs());
  },

  // Comparar fechas ignorando hora
  isSameDay: (fecha1: string | Dayjs, fecha2: string | Dayjs): boolean => {
    return dayjs(fecha1).isSame(dayjs(fecha2), "day");
  },
};
